export const environment = {
    urlSupertoken: "https://authitc.dev.puntosalud.ar/superapi"
};
